import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/css/nucleo-icons.css";
import "assets/scss/conectados.scss";
import "assets/adicional/adicional.css";
import 'react-toastify/dist/ReactToastify.css';

import Index from "views/Index.js";
import LandingPage from "views/pages/LandingPage.js";
import MemberPage from "views/pages/MemberPage.js";
import ProfilePage from "views/pages/ProfilePage.js";
import PastorPage from "views/pages/PastorPage.js";
import MinistriesPage from "views/pages/MinistriesPage.js";
import ConfesseJesus from "views/pages/ConfesseJesus.js";
import ContactPage from "views/pages/ContactPage.js";
import MissionPage from "views/pages/MissionPage.js";
import GCPage from "views/pages/GCPage.js";
import Register from "modules/login/Register.tsx";
import { ToastContainer } from 'react-toastify';
import ExPage from "views/pages/ExPage";



const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
  <ToastContainer />
    <Routes>
      <Route path="/home" element={<Index />} />
      <Route path="/landing-page" element={<LandingPage />} />
      <Route path="/seja-membro" element={<MemberPage />} />
      <Route path="/nossos-pastores" element={<PastorPage />} />
      <Route path="/ministerios" element={<MinistriesPage />} />
      <Route path="/confesse-jesus" element={<ConfesseJesus />} />
      <Route path="/contato" element={<ContactPage />} />
      <Route path="/missao-visao-valores" element={<MissionPage />} />
      <Route path="/encontre-um-gc" element={<GCPage />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  </BrowserRouter>
);
